import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaChevronDown, FaCalendarAlt } from "react-icons/fa";
import heroImage from "../../images/hero/header.png";

function AppHero() {
  const imgRef = useRef(null);
  const [nextConcert, setNextConcert] = useState(null);

  useEffect(() => {
    fetch("/data/concerts.json")
      .then((r) => r.json())
      .then((data) => {
        const today = new Date().toISOString().split("T")[0];
        const upcoming = (data.concerts || [])
          .filter((c) => c.dateISO >= today)
          .sort((a, b) => a.dateISO.localeCompare(b.dateISO));
        setNextConcert(upcoming[0] || null);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!imgRef.current) return;
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight;
      const progress = Math.min(scrollY / heroHeight, 1);
      const blur = progress * 14;
      const brightness = 1 - progress * 0.35;
      imgRef.current.style.filter = `blur(${blur}px) brightness(${brightness})`;
      imgRef.current.style.transform = `scale(${1 + progress * 0.04})`;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToNext = () => {
    document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToConcerts = () => {
    document.getElementById("concerts")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id="hero" className="heroBlock">
      <img
        ref={imgRef}
        className="heroVideo"
        src={heroImage}
        alt="Sax'emble Saxophonorchester Kloster Schöntal"
      />

      <div className="heroOverlay" />

      <div className="heroContent container-fluid">
        <motion.div
          className="yellowBox"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, delay: 0.4, ease: "easeOut" }}
        >
          <h1>Herzlich Willkommen<br />bei Sax'emble!</h1>
          <p>Saxophonorchester Kloster Schöntal</p>
        </motion.div>
      </div>

      {nextConcert && (
        <motion.div
          className="concertBadge"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.65, delay: 1.0, ease: "easeOut" }}
          onClick={scrollToConcerts}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && scrollToConcerts()}
          aria-label={`Nächstes Konzert: ${nextConcert.date} – ${nextConcert.title}`}
        >
          <span className="badgePing" />
          <span className="badgeInner">
            <span className="badgeEyebrow">
              <FaCalendarAlt size={10} />
              Nächstes Konzert
            </span>
            <span className="badgeDate">{nextConcert.date}</span>
            {nextConcert.title && (
              <span className="badgeTitle">{nextConcert.title}</span>
            )}
          </span>
          <span className="badgeArrow">→</span>
        </motion.div>
      )}

      <motion.button
        className="scrollIndicator"
        onClick={scrollToNext}
        aria-label="Weiter scrollen"
        animate={{ y: [0, -8, 0] }}
        transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
      >
        <FaChevronDown size={26} color="white" />
      </motion.button>
    </div>
  );
}

export default AppHero;

